var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 6l-4 4-3-2h-4l-7 7c-2 2-2 5-1 6l28 29c1 1 2 4 0 5L35 69l-4-5 10-10v-3L17 26c-3-3-4-11-1-14l10-9c2-2 7-2 9-1z",
    fill: "#756e78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 2l46 46v6c-3 6-9 12-15 15h-6C63 56 45 38 31 22v-6c4-6 10-13 16-16 2-1 5 1 6 2z",
    fill: "#fc840d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54l23 23-3 4c-3-1-10-1-12 2L15 99H8l-6-6c-3-3-2-6 0-8l14-14c4-4 4-11 3-13z",
    fill: "#fb9369"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 2l46 46v6c-3 6-4 6-8 10-2 2-4 1-6 0-15-13-35-34-49-50-1-1 0-4 1-5l10-9c2-1 5 1 6 2z",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64c-5-4-39-35-51-49-1-2-1-3 1-5 2-3 8-9 11-10l6 1c14 13 33 31 46 48v5c-2 3-7 10-10 12l-3-2z",
    fill: "#fba615"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54l-4 4c1 2 1 9-3 13L2 85c-2 2-3 5 0 8l1 1c0-2 1-4 3-5l16-16 3-5 13 13h4L26 64l4-3z",
    fill: "#f06b37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepair);
export default __webpack_public_path__ + "static/media/repair.07d8a42c9a51b1ebd60c044de062a50f.svg";
export { ForwardRef as ReactComponent };